var _path, _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgService = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#EFF7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1338_39114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9309 32.7066L31.7742 26.5499L31.5154 26.8087C31.309 27.0068 31.0328 27.1157 30.7463 27.1126C30.4599 27.1095 30.1867 26.9945 29.9834 26.7922C29.7812 26.5899 29.6662 26.3158 29.6631 26.0293C29.66 25.7428 29.7688 25.4666 29.967 25.2602L30.2247 25.0025L28.6763 23.4541L23.5156 28.6148L25.064 30.1632L25.3218 29.9045C25.5271 29.6991 25.8064 29.5841 26.097 29.5851C26.3876 29.5851 26.6658 29.7012 26.8712 29.9065C27.0766 30.1119 27.1916 30.3912 27.1916 30.6817C27.1916 30.9723 27.0755 31.2506 26.8692 31.456L26.6114 31.7137L32.7681 37.8704C32.955 38.0562 33.1614 38.2205 33.3832 38.3612L38.4186 33.3258C38.2779 33.1029 38.1147 32.8945 37.9298 32.7066H37.9309Z",
    fill: "url(#paint0_linear_1338_39114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2581 13.1266L14.7416 11.0658L11.1293 9.00293L9.06445 11.0668L11.1293 14.6801L13.1922 15.1966L25.0651 27.0674L27.13 25.0025L15.2581 13.1266Z",
    fill: "url(#paint1_linear_1338_39114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8244 13.3065L35.3857 16.7452L32.2888 15.7133L31.2569 12.6164L34.6967 9.17667C33.7459 8.93332 32.7478 8.94153 31.8011 9.20029C30.8544 9.45904 29.9919 9.96012 29.2978 10.6542C28.6037 11.3484 28.1016 12.2109 27.8418 13.1565C27.582 14.1033 27.5728 15.1003 27.8161 16.0521L16.1147 27.7576C14.9031 27.4496 13.6237 27.5482 12.4726 28.039C11.3226 28.5288 10.3646 29.3831 9.74649 30.4704C9.12836 31.5578 8.88398 32.8177 9.05135 34.057C9.21872 35.2964 9.78859 36.4464 10.6727 37.3305C11.5567 38.2146 12.7068 38.7844 13.9461 38.9518C15.1854 39.1192 16.4453 38.8748 17.5327 38.2567C18.6201 37.6385 19.4734 36.6805 19.9642 35.5305C20.454 34.3805 20.5525 33.1001 20.2455 31.8884L31.951 20.1829C32.9018 20.4242 33.8978 20.415 34.8435 20.1552C35.7892 19.8954 36.6507 19.3944 37.3438 18.7002C38.0369 18.0071 38.538 17.1457 38.7988 16.2C39.0585 15.2543 39.0678 14.2573 38.8265 13.3075L38.8244 13.3065ZM16.2903 35.8406H13.1935L11.645 33.2592L13.1935 30.6789H16.2903L17.8387 33.2592L16.2903 35.8406Z",
    fill: "url(#paint2_linear_1338_39114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7251 36.6579C38.8083 36.4525 38.8709 36.241 38.9161 36.0233C38.9346 35.9361 38.9551 35.8498 38.9664 35.7615C38.9695 35.7348 38.9787 35.7091 38.9818 35.6814C38.989 35.6147 38.9818 35.549 38.9859 35.4822C38.989 35.4165 38.9993 35.3528 38.9993 35.2871C38.9993 35.2522 38.9931 35.2183 38.9921 35.1844C38.989 35.0941 38.9818 35.0048 38.9726 34.9144C38.9613 34.8097 38.9459 34.706 38.9253 34.6022C38.9099 34.5211 38.8945 34.4421 38.873 34.362C38.8411 34.2429 38.8011 34.1258 38.7569 34.0108C38.7343 33.9502 38.7159 33.8886 38.6892 33.8291C38.6122 33.6535 38.5249 33.483 38.4212 33.3208L33.3857 38.3562C34.085 38.807 34.9188 39.0052 35.7464 38.9169C36.4754 38.8388 37.1541 38.5328 37.7086 38.0615C37.7425 38.0328 37.7774 38.0051 37.8102 37.9753C37.8503 37.9383 37.8965 37.9096 37.9345 37.8705C37.9879 37.8172 38.03 37.7545 38.0792 37.6991C38.1172 37.6559 38.1532 37.6128 38.1891 37.5687C38.2682 37.4701 38.3431 37.3705 38.4109 37.2647C38.4201 37.2514 38.4314 37.2391 38.4396 37.2257C38.4622 37.1908 38.4776 37.1518 38.4982 37.1159C38.5618 37.007 38.6245 36.8982 38.6758 36.7832C38.6943 36.7421 38.7066 36.699 38.723 36.6569L38.7251 36.6579Z",
    fill: "url(#paint3_linear_1338_39114)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1338_39114",
    x1: 23.5167,
    y1: 30.9076,
    x2: 38.4196,
    y2: 30.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1338_39114",
    x1: 9.06445,
    y1: 18.0347,
    x2: 27.1289,
    y2: 18.0347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1338_39114",
    x1: 9.00001,
    y1: 24.0006,
    x2: 38.999,
    y2: 24.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1338_39114",
    x1: 33.3857,
    y1: 36.1301,
    x2: 39.0003,
    y2: 36.1301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDAFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1338_39114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30.0021,
    fill: "white",
    transform: "translate(9 9)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgService, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/service.43f24fe6.svg";
export { ForwardRef as ReactComponent };